import type { Namespace } from "@/i18n/types";
import nsAppEN from "./en";
import nsAppJA from "./ja";

export const nsApp = {
  name: "app",
  locales: {
    ja: nsAppJA,
    en: nsAppEN,
  },
} satisfies Namespace<"app", typeof nsAppJA>;
